/* eslint-disable array-callback-return */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import NaverBlogItem from '../../components/store/NaverBlogItem';
import StoreStoryItem from '../../components/store/StoreStoryItem';
import TwitterItem from '../../components/store/TwitterItem';
import EventItem from '../../components/store/EventItem';

class StoreInfoStoryList extends PureComponent {
  state = {
    gotoPage: 1,
    pageSize: 8,
    pageCount: 1,
    con: 0,
    bottomList: [],
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    const { store } = this.props.childProps;
    this._getData(store, 1);
    this._getBlog(store);
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return this.props.match.params.store !== nextProps.match.params.store;
    //return true;
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  componentWillReceiveProps = (nextProps) => {
    //console.log(this.props.match.params.store)
    //console.log(nextProps.match.params.store)
    if (this.props.match.params.store !== nextProps.match.params.store) {
      if (this._isLoad) {
        this.setState({
          bottomList: [],
        });
      }
      this._getData(nextProps.match.params.store, 1);
      this._getBlog(nextProps.match.params.store);
    }
  };
  _getData = async (store, gotoPage) => {
    const result = await this._getDataApi(store, gotoPage);
    //console.log(result)
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const intReturn = result.data[0].intReturn;
    const storeList = result.data[0].listData;
    //console.log(storeList)
    if (intReturn === 0) {
      if (con > 0) {
        if (this._isLoad) {
          this.setState({
            bottomList: this.state.bottomList.concat(storeList),
            con,
            pageCount,
            gotoPage,
            storeList,
          });
        }
      } else {
      }
    }
  };
  _getDataApi = (store, gotoPage) => {
    const { apiUrl, loginId } = this.props;
    //const { idx, store } = this.props.childProps;
    const { pageSize } = this.state;
    //console.log(store)
    return axios
      .post(apiUrl + '/storeStoryList', {
        params: {
          board_id: 301,
          gotoPage: gotoPage,
          shop: store,
          pageSize: pageSize,
          loginId: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _getBlog = async (store) => {
    //const { allList } = this.state;
    const result = await this._getBlogApi(store);
    const intReturn = result.data[0].intReturn;
    const blogList = result.data[0].listData;
    //console.log(blogList)
    if (intReturn === 0) {
      //allList.concat(blogList)

      blogList.map((item, index) => {
        item.gubun = 'blog';
      });
      //console.log(blogList)
      if (this._isLoad) {
        this.setState({
          bottomList: this.state.bottomList.concat(blogList),
          blogList,
        });
      }
    }
  };
  _getBlogApi = (store) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/getNaverBlogStore', {
        params: {
          store: store,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _more = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 < pageCount) {
      this._getData(gotoPage + 1);
    } else {
      toast.warn('페이지의 마지막입니다.');
    }
  };
  _renderBlogItem = () => {
    const { blogList } = this.state;

    blogList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    const list = blogList.map((item, index) => {
      return (
        <NaverBlogItem
          key={index}
          gubun={item.gubun}
          bloggerlink={item.bloggerlink}
          bloggername={item.bloggername}
          description={item.description}
          link={item.link}
          postdate={item.postdate}
          title={item.title}
        />
      );
    });

    return list;
  };
  _renderItem = () => {
    const { storeList } = this.state;

    const list = storeList.map((item, index) => {
      return (
        <StoreStoryItem
          key={index}
          idx={item.idx}
          id={item.id}
          storeName={item.storeName}
          categoryName={item.categoryName}
          title={item.title}
          readnum={item.readnum}
          chuchon={item.chuchon}
          likes={item.likes}
          comment_num={item.comment_num}
          writeday={item.writeday}
          filename={item.filename}
          content={item.content}
          active={item.active}
        />
      );
    });
    return list;
  };
  _renderBottomItem = () => {
    const { bottomList } = this.state;

    bottomList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    /*gubun에 따라 컴포넌트 분기 시킬것!*/

    const list = bottomList.map((item, index) => {
      if (item.gubun === 'blog') {
        return (
          <NaverBlogItem
            key={index}
            gubun={item.gubun}
            bloggerlink={item.bloggerlink}
            bloggername={item.bloggername}
            description={item.description}
            link={item.link}
            postdate={item.postdate}
            title={item.title}
          />
        );
      } else if (item.gubun === 'story') {
        return (
          <StoreStoryItem
            key={index}
            gubun={item.gubun}
            idx={item.idx}
            id={item.id}
            storeName={item.storeName}
            categoryName={item.categoryName}
            title={item.title}
            readnum={item.readnum}
            chuchon={item.chuchon}
            likes={item.likes}
            comment_num={item.comment_num}
            writeday={item.writeday}
            filename={item.filename}
            content={item.content}
            active={item.active}
          />
        );
      } else if (item.gubun === 'twitter') {
        return (
          <TwitterItem
            key={index}
            gubun={item.gubun}
            id={item.id_str}
            postdate={item.postdate}
            source={item.source}
            text={item.full_text}
            media={item.entities}
          />
        );
      } else if (item.gubun === 'event') {
        return (
          <EventItem
            key={index}
            idx={item.idx}
            bannerFile={item.bannerFile}
            LinkURL={item.LinkURL}
            Linktarget={item.Linktarget}
            title={item.title}
            comment={item.comment}
            banner={item.banner}
            LinkUrl_M={item.LinkUrl_M}
            Linktarget_M={item.Linktarget_M}
            adComIdx={item.adComIdx}
            pageCode={item.pageCode}
            gubun={item.gubun}
            comment_count={item.comment_count}
            openDay={item.openDay}
          />
        );
      }
    });
    return list;
  };
  render() {
    const { bottomList, blogList } = this.state;
    return (
      <Fragment>
        <ul className="store_card_list">
          <li className="store_card_item sm_item only">
            {/* only 추가 220118 */}
            <div className="inner_item">
              {/* {bottomList ? this._renderBottomItem() : null} */}
              {blogList ? this._renderBlogItem() : null}
              {/* 카드 내용 , 종료 off (콜라보 카페 cafe, 서울 합정점 su_hj, 대전 중앙로점 dj_ja, 광주 충장로점 gj_cj, 부산 서면점 bs_sm) / */}
            </div>
          </li>
        </ul>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(React.memo(StoreInfoStoryList)));
